import { PolylineEdge, PolylineEdgeModel } from '@logicflow/core'

class FlowTransitionModel extends PolylineEdgeModel {
  static extendKey = 'FlowTransitionModel'
  
  getEdgeStyle() {
    const style = super.getEdgeStyle()
    style.stroke = '#333333'
    style.strokeWidth = 3  // 加粗：从 2 改为 3
    
    // 高亮状态
    if (this.properties.state === 'active') {
      style.stroke = '#67c23a'
      style.strokeWidth = 4  // 加粗：从 3 改为 4
    } else if (this.properties.state === 'history') {
      style.stroke = '#909399'
      style.strokeWidth = 3  // 保持一致
    }
    
    return style
  }

  getEdgeAnimationStyle() {
    const style = super.getEdgeAnimationStyle()
    style.strokeDasharray = '5 5'
    style.animationDuration = '30s'
    return style
  }

  getTextStyle() {
    const style = super.getTextStyle()
    style.color = '#333333'
    style.fontSize = 12
    style.background = {
      fill: '#ffffff',
      height: 20,
      stroke: '#333333',
      radius: 10
    }
    return style
  }
}

class FlowTransitionView extends PolylineEdge {
  static extendKey = 'FlowTransitionView'
}

const FlowTransition = {
  type: 'flow:transition',
  view: FlowTransitionView,
  model: FlowTransitionModel
}

export { FlowTransitionView, FlowTransitionModel }
export default FlowTransition
